/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./myPagination.vue?vue&type=template&id=6a81fc38&scoped=true"
import script from "./myPagination.vue?vue&type=script&lang=js"
export * from "./myPagination.vue?vue&type=script&lang=js"
import style0 from "./myPagination.vue?vue&type=style&index=0&id=6a81fc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81fc38",
  null
  
)

export default component.exports